// Entity
import { AssignedToTaskboardTaskFormatting } from "../../legacyPlanner/task/taskFormatting/AssignedToTaskboardTaskFormatting";
/** Class to handle serialization/deserialization for TaskBoardFormatAssignedTo data */ export class TaskBoardFormatAssignedToSerializationHandler {
    /** serialize to IGraphAssignedToTaskBoardTaskFormattingResource */ toSerializable(key, value) {
        return value.toGraphSerializable();
    }
    /** build IAssignedToTaskboardTaskFormatting from IGraphAssignedToTaskBoardTaskFormattingResource */ fromSerializable(key, serializableValue) {
        return AssignedToTaskboardTaskFormatting.builder.fromGraphResource(serializableValue).build();
    }
}
